import React, { useEffect, useRef, useState } from "react";
import SelectFromLibr from "./SelectFromLibr";
import DefaultQuestion from "./DefaultQuestion";
import QuestionListAssessment from "./QuestionListAssessment";
import axios from "../../axios";
import { useSelector } from "react-redux";
import ProgressBar from "../../Helper/ProgressBar";
import SourceLibrary from "../../Enum/SourceLibraryEnum";
import OperationType from "../../Enum/OperationTypeEnum";
import ComponentType from "../../Enum/ComponentTypeEnum";
import { useNavigate } from "react-router-dom";
import PublishPreviewQB from "./PublishPreviewQB";
import FailedApiErrorPopup from "./FailedApiErrorPopup";
import AiGenerateQuestions from "./AiGenerateQuestions";
import CheckDuplicatePop from "./CheckDuplicatePop";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Tooltip,
  Typography,
  DialogTitle,
  DialogActions,
  IconButton,
} from "@mui/material";
import { Trash2, ListChecks, Sparkles, Upload, Search } from "lucide-react";
import { WarningAmber } from "@mui/icons-material";
import QuestionPaperMapper from "./QuestionPaperMaper";
import { LibraryButton } from "./UpdateQustion";
import { hasDescriptiveAutoAssessment, hasFeature } from "../../Utils/features";

const CreateQuestion = ({
  componentType,
  setClickFromCreate,
  assessmentDetails,
  setAssessmentDetails,
  setUnsavedChanges,
  redirectStateData,
  selectedBox,
  leftSidebarSize,
}) => {
  const [questionTypeData, setQuestionTypeData] = useState([]);
  const [difficultyLevel, setDifficultyLevel] = useState([]);
  const [sourceLibrary, setSourceLibrary] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [hidePopupCheck, setHidePopupCheck] = useState(false);
  const [viewErrorMsg, setViewErrorMsg] = useState("");
  const [apiViewErrorMsg, setApiViewErrorMsg] = useState("");
  const [questionData, setquestionData] = useState([]);
  const [openQuestionBox, setOpenQuestionBox] = useState(false);
  const [isopenPopupDupli, isSetOpenPopupDupli] = useState(false);

  // Delete Confirmation State
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);

  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);

  const hasDescriptiveAutoAssessmentFlag = hasDescriptiveAutoAssessment;

  const isAutoEvalMode =
    selectedBox === "auto-evaluate" ||
    selectedBox?.autoEvaluate === true ||
    selectedBox?.isAutoEvaluate === true;

  const {
    standard_id,
    subject_id,
    section_id,
    total_duration,
    name,
    description,
  } = assessmentDetails;
  const school_id = JSON.parse(localStorage.getItem("schoolId"));

  const [click, setClick] = useState(false); // PublishPreviewQB toggle
  const [click1, setClick1] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const domainsData = useSelector((state) => state.initialData.domain);
  const skillsData = useSelector((state) => state.initialData.skills);
  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const [newQuestionPaperMaper, setNewQuestionPaperMaper] = useState(false);
  const [copyPrevSettings, setCopyPrevSettings] = useState(true);
  const [showProcessingDialog, setShowProcessingDialog] = useState(false);
  const [showErrorInputField, setShowErrorInputField] = useState(false);
  const [getErrorMsg, setGetErrorMsg] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [questionType, setQuestionType] = useState([]);

  // 👈 Changed to Array for "Expand All" functionality
  const [activeQuestions, setActiveQuestions] = useState([]);

  const [questionScoreCounter, setQuestionScoreCounter] = useState({
    skills: [],
    questionType: [],
    difficultyLevel: [],
  });

  const [searchTerm, setSearchTerm] = useState("");
  const questionRefs = useRef({});
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  // ==========================================
  // 👈 COMPONENT TYPE FLAGS (Marks logic sirf non-QB ke liye)
  // ==========================================
  const isQuestionBank = componentType === ComponentType.QUESTION_BANK;

  const checkQuestionTypes = async () => {
    try {
      const res = await axios.get(
        `/api/v1/questionType/get/school/${school_id}`,
      );
      if (res.data.data.length > 0) setQuestionType(res.data.data);
    } catch (error) {
      console.log(error, "error while fetching quwstion type");
    }
  };

  useEffect(() => {
    checkQuestionTypes();
  }, [school_id]);

  const [dropdownList, setDropdownList] = useState({
    skills: skillsData,
    types: questionType,
    domains: null,
    chapters: null,
    difficultyLevels: difficulty_levelData,
  });
  const { skills, domains, chapters, difficultyLevels } = dropdownList;
  const { types } = dropdownList;

  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`,
      );
      chapters &&
        setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  useEffect(() => {
    setDropdownList((prev) => ({
      ...prev,
      skills: skillsData,
      types: questionType,
      domains: domainsData,
      difficultyLevels: difficulty_levelData,
    }));
  }, [skills, types, domains, difficultyLevels, questionType]);

  const [questions, setQuestions] = useState([]);
  const saveTimer = useRef(null);

  // ==========================================
  // 👈 LOCAL STORAGE AUTO-SAVE LOGIC
  // ==========================================
  useEffect(() => {
    if (!questions || questions.length === 0) return;
    if (saveTimer.current) clearTimeout(saveTimer.current);

    saveTimer.current = setTimeout(() => {
      const key = `temp_Questions_${componentType}`;

      if (componentType === ComponentType.ASSESSMENT) {
        localStorage.setItem("currentStep", 3);
        localStorage.setItem(
          key,
          JSON.stringify({ assessmentDetails, questions }),
        );
      }
      if (componentType === ComponentType.HOMEWORK) {
        localStorage.setItem("currentStepHW", 3);
        localStorage.setItem(
          key,
          JSON.stringify({ HomeWorkDetails: assessmentDetails, questions }),
        );
      }
      if (componentType === ComponentType.QUESTION_BANK) {
        localStorage.setItem(
          key,
          JSON.stringify({ questionBankData: assessmentDetails, questions }),
        );
      }
      console.log("✅ Auto-saved to localStorage");
    }, 3000);

    return () => {
      if (saveTimer.current) clearTimeout(saveTimer.current);
    };
  }, [questions, assessmentDetails, componentType]);

  // ==========================================
  // 👈 LOCAL STORAGE RESTORE LOGIC
  // ==========================================
  useEffect(() => {
    const key = `temp_Questions_${componentType}`;
    const savedTempLocal = JSON.parse(localStorage.getItem(key));

    if (!savedTempLocal) return;

    if (
      componentType === ComponentType.HOMEWORK &&
      savedTempLocal.HomeWorkDetails
    ) {
      setAssessmentDetails(savedTempLocal.HomeWorkDetails);
      setQuestions(savedTempLocal.questions || []);
    }
    if (
      componentType === ComponentType.ASSESSMENT &&
      savedTempLocal.assessmentDetails
    ) {
      setAssessmentDetails(savedTempLocal.assessmentDetails);
      setQuestions(savedTempLocal.questions || []);
    }
    if (
      componentType === ComponentType.QUESTION_BANK &&
      savedTempLocal.questionBankData
    ) {
      setAssessmentDetails(savedTempLocal.questionBankData);
      setQuestions(savedTempLocal.questions || []);
    }
  }, [componentType]);

  const getBaseQuestionTemplate = () => {
    const isAdaptiveSelected =
      selectedBox === "adaptive" ||
      selectedBox === "auto-evaluate" ||
      selectedBox?.adaptive ||
      selectedBox?.isAdaptive ||
      selectedBox?.autoEvaluate;
    const mcqType = types?.find((t) => t.type === "multiple choice");
    return {
      standard_id: standard_id ? standard_id.id : null,
      subject_id: subject_id ? subject_id.id : null,
      section_id: section_id ? section_id.id : null,
      book_id: null,
      chapter_id: null,
      domain_id: null,
      skill_id: null,
      difficulty_level: null,
      question_type: isAdaptiveSelected ? "false" : "null",
      type_id: isAdaptiveSelected && mcqType ? mcqType.id : null,
      title: null,
      correct_score: 0,
      is_question_edited: false,
      is_mandatory: false,
      add_to: "all",
      add_to_mock: false,
      attachments: [],
      options: [
        { key: "A", value: null },
        { key: "B", value: null },
        { key: "C", value: null },
        { key: "D", value: null },
      ],
      correct_answers: [
        {
          option_key: null,
          value: null,
          reason_for_answer: { attachment: null, explanation: null },
        },
      ],
    };
  };

  const addMoreQuestion = () => {
    setQuestions((prev) => {
      const baseQuestion = getBaseQuestionTemplate();
      if (copyPrevSettings && prev.length > 0) {
        const previous = prev[prev.length - 1];
        const copiedTypeId = previous.type_id ?? baseQuestion.type_id;
        const copiedQuestionType =
          previous.question_type ?? baseQuestion.question_type;
        const copiedIsManuallyGraded = copiedQuestionType === "true";

        let newQuestion = {
          ...baseQuestion,
          book_id: previous.book_id,
          chapter_id: previous.chapter_id,
          skill_id: previous.skill_id,
          domain_id: previous.domain_id,
          difficulty_level: previous.difficulty_level,
          type_id: copiedTypeId,
          question_type: copiedQuestionType,
          correct_score: previous.correct_score,
          add_to: "all",
          add_to_mock: false,
        };

        if (
          hasDescriptiveAutoAssessmentFlag &&
          isAutoEvalMode &&
          copiedIsManuallyGraded &&
          previous.subjective_evaluation
        ) {
          const hasRealContent =
            (previous.subjective_evaluation.expectedAnswer &&
              previous.subjective_evaluation.expectedAnswer.trim()) ||
            (Array.isArray(previous.subjective_evaluation.rubric) &&
              previous.subjective_evaluation.rubric.length > 0);
          newQuestion.subjective_evaluation = {
            enabled: hasRealContent
              ? (previous.subjective_evaluation.enabled ?? false)
              : false,
            expectedAnswer: previous.subjective_evaluation.expectedAnswer || "",
            rubric: Array.isArray(previous.subjective_evaluation.rubric)
              ? previous.subjective_evaluation.rubric.map((r) => ({ ...r }))
              : [],
          };
        } else if (
          hasDescriptiveAutoAssessmentFlag &&
          isAutoEvalMode &&
          copiedIsManuallyGraded &&
          !previous.subjective_evaluation
        ) {
          newQuestion.subjective_evaluation = {
            enabled: false,
            expectedAnswer: "",
            rubric: [],
          };
        }
        return [...prev, newQuestion];
      }
      return [...prev, baseQuestion];
    });
  };

  const checkAllDataField = () => {
    let hasError = false;
    const isQuestionLibraryComponent =
      componentType === ComponentType.QUESTION_BANK;

    questions.forEach((question, index) => {
      if (!question.title) {
        setGetErrorMsg(`Title missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.skill_id) {
        setGetErrorMsg(`Skill missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.type_id) {
        setGetErrorMsg(`Question Type missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.chapter_id) {
        setGetErrorMsg(`Book & Chapter missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.correct_score) {
        setGetErrorMsg(`Correct Score missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.difficulty_level) {
        setGetErrorMsg(`Difficulty Level missing in question ${index + 1}`);
        hasError = true;
      }

      if (isQuestionLibraryComponent) {
        const isAddToMissing =
          !question?.add_to || question.add_to.trim() === "";
        const isMockMissing =
          question?.add_to_mock === undefined ||
          question?.add_to_mock === false;
        if (isAddToMissing && isMockMissing) {
          setGetErrorMsg(`Add to missing in question ${index + 1}`);
          hasError = true;
        }
      }

      const skipOptionValidation = isQuestionLibraryComponent
        ? question.question_type === "true"
        : hasDescriptiveAutoAssessmentFlag &&
          isAutoEvalMode &&
          question.question_type === "true";

      if (question.type_id && !skipOptionValidation) {
        if (Array.isArray(question.options) && question.options.length > 0) {
          question.options.forEach((opt) => {
            if (!opt?.key || opt.key.trim() === "") {
              setGetErrorMsg(`Option key missing in question ${index + 1}`);
              hasError = true;
            }
            if (!opt?.value || opt.value.trim() === "") {
              setGetErrorMsg(`Option value missing in question ${index + 1}`);
              hasError = true;
            }
          });
        }
      }

      if (question.type_id && !skipOptionValidation) {
        if (Array.isArray(question.correct_answers)) {
          question?.correct_answers?.forEach((ans) => {
            if (question?.options?.length > 0) {
              if (!ans?.option_key || ans.option_key.trim() === "") {
                setGetErrorMsg(`Option key missing in question ${index + 1}`);
                hasError = true;
              }
            }
          });
        }
      }
    });

    if (hasError) {
      setShowErrorInputField(true);
      return true;
    }
    return false;
  };

  const findDuplicateQuestions = () => {
    const seen = new Set();
    const duplicates = [];
    questions.forEach((question, index) => {
      const id = question.id || question.b4sQuestion;
      if (question.is_question_edited || !id) return;
      if (seen.has(id)) duplicates.push(index + 1);
      else seen.add(id);
    });

    if (duplicates.length > 0) {
      setViewErrorMsg(`Duplicate question found at Q${duplicates.join(", Q")}`);
      isSetOpenPopupDupli(true);
      return true;
    }
    return false;
  };

  const handleAdaptiveQuesType = () => {
    let nonAdaptiveQustionType = [];
    let hasNonAdaptive = false;
    questions.forEach((question, index) => {
      if (selectedBox === "adaptive" && selectedBox === "auto-evaluate") {
        const isCheckNonMCQ = question?.options?.length === 0;
        if (isCheckNonMCQ) {
          hasNonAdaptive = true;
          nonAdaptiveQustionType.push(index + 1);
        }
      }
      setHidePopupCheck(hasNonAdaptive);
    });

    if (hasNonAdaptive) {
      setOpenPopup(true);
      setViewErrorMsg(
        `Non-MCQ questions are found in Adaptive Assessment. \nPlease check the questions Q${nonAdaptiveQustionType.join(", Q")}`,
      );
    } else {
      setOpenPopup(false);
    }
  };

  const buildCleanedQuestions = (rawQuestions) => {
    return (rawQuestions || []).map((val) => {
      const q = { ...val };
      if (q.is_question_edited || q.id !== undefined) delete q.id;
      const isManuallyGraded = q.question_type === "true";
      const isQuestionBank = componentType === ComponentType.QUESTION_BANK;

      if (isQuestionBank) {
        if (isManuallyGraded)
          q.subjective_evaluation = {
            enabled: false,
            expectedAnswer: "",
            rubric: [],
          };
        else delete q.subjective_evaluation;
        return q;
      }

      if (!hasDescriptiveAutoAssessmentFlag || !isAutoEvalMode) {
        delete q.subjective_evaluation;
        return q;
      }
      if (!isManuallyGraded) {
        delete q.subjective_evaluation;
        return q;
      }

      const se = q.subjective_evaluation;
      const hasContent =
        (se?.expectedAnswer && se.expectedAnswer.trim()) ||
        (Array.isArray(se?.rubric) && se.rubric.length > 0);
      if (!hasContent) {
        delete q.subjective_evaluation;
        return q;
      }

      const isAiEnabled = se?.enabled ?? false;
      let finalRubric = [];
      if (isAiEnabled)
        finalRubric = (se.rubric || []).filter(
          (r) => (r.criterion && r.criterion.trim()) || Number(r.maxMarks) > 0,
        );
      q.subjective_evaluation = {
        enabled: isAiEnabled,
        expectedAnswer: se.expectedAnswer || "",
        rubric: finalRubric,
      };
      return q;
    });
  };

  const findTotalMarks = () =>
    questions?.reduce((acc, curr) => acc + Number(curr.correct_score), 0);

  // ==========================================
  // 👈 MARKS LOGIC — SIRF NON-QB KE LIYE
  // ==========================================
  const maxMarks = isQuestionBank
    ? 0
    : Number(assessmentDetails?.maxMarks) || 0;
  const totalMarks = findTotalMarks() || 0;
  const marksDiff = totalMarks - maxMarks;
  const isMarksMismatch =
    !isQuestionBank && maxMarks > 0 && totalMarks !== maxMarks;
  const marksStatus =
    totalMarks === maxMarks && maxMarks > 0
      ? "match"
      : totalMarks > maxMarks
        ? "exceeded"
        : "short";

  const attentionCount = (questions || []).filter((q) => {
    const isMissingBasic =
      !q.title ||
      !q.skill_id ||
      !q.type_id ||
      !q.chapter_id ||
      !q.correct_score ||
      !q.difficulty_level;
    let isMissingOptions = false;
    if (q.type_id) {
      if (Array.isArray(q.options) && q.options.length > 0) {
        isMissingOptions = q.options.some((opt) => !opt?.key || !opt?.value);
      }
      if (Array.isArray(q.correct_answers)) {
        isMissingOptions =
          isMissingOptions ||
          q.correct_answers.some(
            (ans) =>
              q?.options?.length > 0 &&
              (!ans?.option_key || ans.option_key.trim() === ""),
          );
      }
    }
    return isMissingBasic || isMissingOptions;
  }).length;

  const handleCreateAssessment = async () => {
    // 👈 Marks validation sirf non-QB ke liye
    if (!isQuestionBank && maxMarks > 0 && totalMarks !== maxMarks) {
      toast.error(
        marksStatus === "exceeded"
          ? `Total marks exceeded by ${marksDiff}. Please reduce ${marksDiff} mark(s).`
          : `${Math.abs(marksDiff)} mark(s) remaining. Please add more questions or increase marks.`,
      );
      return;
    }

    const cleanedQuestions = buildCleanedQuestions(questions);
    const isHeavyAssessment = cleanedQuestions.length > 20;

    if (isHeavyAssessment) setShowProcessingDialog(true);
    else setIsInProgress(true);

    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id:
        componentType === ComponentType.ASSESSMENT
          ? null
          : assessmentDetails.type_id,
      assessmentTypeId: assessmentDetails.assessmentTypeId,
      assessmentEventId: assessmentDetails.assessmentEventId,
      ...(componentType === ComponentType.HOMEWORK
        ? {
            academic_session_id: academicSessionId,
            timetable_session_id: timeTableSessionId,
          }
        : {
            academicSessionId: academicSessionId,
            timetableSessionId: timeTableSessionId,
          }),
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "draft",
      isAdaptive: selectedBox === "adaptive" ? true : false,
      autoEvalEnabled: isAutoEvalMode ? true : false,
      total_duration: assessmentDetails.total_duration,
      questions: cleanedQuestions,
    };

    try {
      if (componentType === ComponentType.ASSESSMENT) {
        let res = await axios.post(`/api/v1/assessment/create`, newAssessment);
        if (res) {
          if (redirectStateData !== null)
            navigate("/liveSession", { state: redirectStateData });
          else navigate("/publishedAssessment", { selectedBox: selectedBox });
          localStorage.setItem("isCheckAdaptive", res?.data?.data?.isAdaptive);
        }
      } else if (componentType === ComponentType.HOMEWORK) {
        let res = await axios.post(`/api/v1/homework/create`, newAssessment);
        if (res) {
          if (redirectStateData !== null)
            navigate("/liveSession", { state: redirectStateData });
          else navigate("/PublishedHomework");
        }
      } else if (componentType === ComponentType.QUESTION_BANK) {
        let res = await axios.post(
          `/api/v1/questionBank/create`,
          newAssessment,
        );
        if (res) {
          navigate("/questionLibrary");
        }
      }
    } catch (error) {
      setIsInProgress(false);
      console.log("error", error);
      toast.error("Failed to save. Please try again.");
    } finally {
      if (componentType === ComponentType.ASSESSMENT) {
        localStorage.removeItem("temp_Questions_ASSESSMENT");
        localStorage.removeItem("currentStep");
        localStorage.removeItem("assessmentDetails");
        localStorage.removeItem("selectedBox");
      }
      if (componentType === ComponentType.HOMEWORK) {
        localStorage.removeItem("temp_Questions_HOMEWORK");
        localStorage.removeItem("currentStepHW");
        localStorage.removeItem("HomeWorkDetails");
      }
      if (componentType === ComponentType.QUESTION_BANK)
        localStorage.removeItem("temp_Questions_QUESTION_BANK");
      setShowProcessingDialog(false);
      setIsInProgress(false);
    }
  };

  const handleNextClick = () => {
    // 👈 Marks validation sirf non-QB ke liye
    if (!isQuestionBank && maxMarks > 0 && isMarksMismatch) {
      toast.error(
        marksStatus === "exceeded"
          ? `Total marks exceeded by ${marksDiff}. Please reduce.`
          : `${Math.abs(marksDiff)} mark(s) remaining. Please add more.`,
      );
      return;
    }

    if (attentionCount > 0) {
      toast.error(
        "Some questions are incomplete. Please check 'Need attention' items.",
      );
      return;
    }

    setClick(true); // Opens PublishPreviewQB
  };

  const setInitialDataInCounter = () => {
    let skills = [];
    skillsData.map((skill) =>
      skills.push({ value: 0, label: skill.name, id: skill.id }),
    );
    setQuestionScoreCounter((prev) => ({ ...prev, skills: skills }));
    let qType = [];
    questionType.map((type) =>
      qType.push({ value: 0, label: type.name, id: type.id }),
    );
    setQuestionScoreCounter((prev) => ({ ...prev, questionType: qType }));
    setQuestionTypeData(qType);
    let dLevel = [];
    difficulty_levelData.map((level) =>
      dLevel.push({ value: 0, label: level.name, id: level.id }),
    );
    setQuestionScoreCounter((prev) => ({ ...prev, difficultyLevel: dLevel }));
    setDifficultyLevel(dLevel);
  };

  useEffect(() => {
    setInitialDataInCounter();
  }, []);

  useEffect(() => {
    setInitialDataInCounter();
    questions?.map((item) => {
      const correctScore = Number(item.correct_score);
      if (item.skill_id !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.skills.map((val) => {
            if (val.id == item.skill_id) val["value"] += correctScore;
            return val;
          });
          return { ...prev, skills: current };
        });
      }
      if (item.question_type !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.questionType.map((val) => {
            if (val.id == item.type_id) val["value"] += correctScore;
            return val;
          });
          return { ...prev, questionType: current };
        });
      }
      if (item.difficulty_level !== null) {
        setQuestionScoreCounter((prev) => {
          let current = prev.difficultyLevel.map((val) => {
            if (val.id == item.difficulty_level) val["value"] += correctScore;
            return val;
          });
          return { ...prev, difficultyLevel: current };
        });
      }
    });
  }, [questions]);

  const getquestiondata = (data) => setquestionData(data);

  const skillToDomainNameMap = {
    Remember: "Factual",
    Understand: "Conceptual",
    Apply: "Conceptual",
    Analyze: "Procedural",
    Evaluate: "Metacognitive",
    Create: "Metacognitive",
    None: "None",
  };
  const domainNameToIdMap = Object.fromEntries(
    Array.isArray(domains) ? domains.map((d) => [d.name, d.id]) : [],
  );
  const skillsWithDomainId =
    Array.isArray(skills) &&
    skills.map((skill) => {
      const domainName = skillToDomainNameMap[skill.name];
      const domainId = domainNameToIdMap[domainName] || null;
      return { ...skill, domain_id: domainId };
    });

  const noneSkill = skillsWithDomainId?.find((skill) => skill.name === "None");
  const noneDifficulty = difficultyLevel?.find((d) => d.label === "None");

  const handleMapperSave = (mapperQuestions) => {
    const othersBook = chapters
      ?.flatMap((section) => section.bookInfo || [])
      ?.find((book) => book?.name?.toLowerCase() === "others");
    const othersChapter = chapters
      ?.flatMap((section) => section.bookInfo || [])
      ?.flatMap((book) => book.chapterData || [])
      ?.find((chapter) => chapter?.chapterName?.toLowerCase() === "others");

    setQuestions((prev) => {
      const updated = [...prev];
      mapperQuestions.forEach((mq) => {
        const base = getBaseQuestionTemplate();
        const selectedType = types.find((t) => t.id === mq.type_id);
        let question = {
          ...base,
          title: mq.title,
          correct_score: mq.correct_score,
          skill_id: noneSkill?.id ?? null,
          domain_id: noneSkill?.domain_id ?? null,
          difficulty_level: noneDifficulty?.id ?? null,
          book_id: othersBook?.id ?? null,
          chapter_id: othersChapter?.id ?? null,
          type_id: mq.type_id,
          question_type: String(selectedType?.is_manually_graded),
          attachments: Array.isArray(mq.attachments)
            ? mq.attachments.map((att) =>
                typeof att === "string" ? att : att.url,
              )
            : [],
        };

        if (selectedType?.is_manually_graded === false) {
          question.options = Array.from(
            { length: mq.mcqOptionsCount },
            (_, i) => ({
              key: String.fromCharCode(65 + i),
              value: `Option ${String.fromCharCode(65 + i)}`,
            }),
          );
          question.correct_answers = [
            {
              option_key: mq.correct_answer ?? null,
              value:
                mq.correct_answer != null
                  ? `Option ${mq.correct_answer}`
                  : null,
              reason_for_answer: {
                explanation: mq.teacher_note ?? null,
                attachments: null,
              },
            },
          ];
          delete question.subjective_evaluation;
        } else {
          question.options = [];
          question.correct_answers = [
            {
              value: null,
              reason_for_answer: {
                explanation: mq.teacher_note ?? null,
                attachments: null,
              },
            },
          ];
          if (hasDescriptiveAutoAssessmentFlag && isAutoEvalMode)
            question.subjective_evaluation = {
              enabled: false,
              expectedAnswer: "",
              rubric: [],
            };
        }
        updated.push(question);
      });
      return updated;
    });
  };

  const isAdaptiveCase =
    selectedBox === "adaptive" ||
    selectedBox?.adaptive ||
    selectedBox?.isAdaptive;
  const getColClass = () =>
    isAdaptiveCase
      ? "col-md-6"
      : componentType === ComponentType.QUESTION_BANK
        ? "col-md-3"
        : "col-md-4";

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (!value) {
      setActiveQuestions([]);
      return;
    }

    const lowerValue = value.toLowerCase();
    const foundIndex = questions.findIndex(
      (q) =>
        q?.title?.toLowerCase().includes(lowerValue) ||
        (parseInt(value) && parseInt(value) - 1 === questions.indexOf(q)),
    );
    if (foundIndex !== -1) {
      scrollToQuestion(foundIndex);
    }
  };

  const scrollToQuestion = (index) => {
    setActiveQuestions([index]);
    setTimeout(() => {
      const element = questionRefs.current[index];
      const container = scrollContainerRef.current;
      if (!element || !container) return;
      const elementTop = element.offsetTop;
      container.scrollTo({ top: elementTop - 120, behavior: "smooth" });
    }, 100);
  };

  const handleDeleteClick = (index, e) => {
    e.stopPropagation();
    setQuestionToDelete(index);
    setDeleteConfirmOpen(true);
  };
  const confirmDeleteQuestion = () => {
    if (questionToDelete !== null)
      setQuestions((prev) => prev.filter((_, i) => i !== questionToDelete));
    setDeleteConfirmOpen(false);
    setQuestionToDelete(null);
  };

  const handleExpandAll = () => {
    const allIndices = questions.map((_, i) => i);
    setActiveQuestions(allIndices);
  };

  const handleCollapseAll = () => {
    setActiveQuestions([]);
  };

  const toggleQuestion = (index) => {
    setActiveQuestions((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F9FAFB",
        overflow: "hidden",
      }}
    >
      {/* ========================================== */}
      {/* 1. STICKY HEADER 1 (Title + Library Buttons + Actions) */}
      {/* ========================================== */}
      <div
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #E5E7EB",
          padding: "12px 24px",
          zIndex: 10,
          flexShrink: 0,
        }}
      >
        <div className="d-flex align-items-center justify-content-between gap-3 w-100">
          {/* Left: Title & Icon */}
          <div
            className="d-flex align-items-center gap-3"
            style={{ flexShrink: 0 }}
          >
            <div
              onClick={() => {
                if (componentType === ComponentType.QUESTION_BANK) {
                  setClickFromCreate(false);
                } else {
                  setClickFromCreate(1);
                }
              }}
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "36px",
                height: "36px",
                backgroundColor: "#FFF1E6",
                color: "#F28C28",
                fontSize: "18px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              &lt;
            </div>
            <div className="d-flex flex-column" style={{ maxWidth: "250px" }}>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#1f2937",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={name}
              >
                {name || "Create Assessment"}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  color: "#6B7280",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {componentType === ComponentType.QUESTION_BANK
                  ? "Question Bank"
                  : "Assessment"}{" "}
                • {subject_id?.name || "Subject"}
              </span>
            </div>
          </div>

          {/* Center: Library Buttons */}
          <div
            className="d-flex flex-wrap gap-2 justify-content-center"
            style={{ flex: 1 }}
          >
            <button
              onClick={() => {
                setClick1(true);
                setSourceLibrary(SourceLibrary.FROM_SCHOOL_LIBRARY);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 14px",
                border: "1px solid #FDE68A",
                borderRadius: "8px",
                backgroundColor: "#FFF7ED",
                color: "#92400E",
                fontWeight: 600,
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#FFEDD5";
                e.currentTarget.style.borderColor = "#FCD34D";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#FFF7ED";
                e.currentTarget.style.borderColor = "#FDE68A";
              }}
            >
              <ListChecks size={16} /> School Bank
            </button>

            <button
              onClick={() => {
                setClick1(true);
                setSourceLibrary(SourceLibrary.FROM_B4S_LIBRARY);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "8px 14px",
                border: "1px solid #FDE68A",
                borderRadius: "8px",
                backgroundColor: "#FFF7ED",
                color: "#92400E",
                fontWeight: 600,
                fontSize: "13px",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#FFEDD5";
                e.currentTarget.style.borderColor = "#FCD34D";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#FFF7ED";
                e.currentTarget.style.borderColor = "#FDE68A";
              }}
            >
              <ListChecks size={16} /> B4S Bank
            </button>

            {componentType === ComponentType.QUESTION_BANK &&
              hasFeature("AI_QUERY") && (
                <button
                  onClick={() => setOpenQuestionBox(true)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "8px 14px",
                    border: "1px solid #FDE68A",
                    borderRadius: "8px",
                    backgroundColor: "#FFF7ED",
                    color: "#92400E",
                    fontWeight: 600,
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#FFEDD5";
                    e.currentTarget.style.borderColor = "#FCD34D";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#FFF7ED";
                    e.currentTarget.style.borderColor = "#FDE68A";
                  }}
                >
                  <Sparkles size={16} /> AI Generator
                </button>
              )}

            {!isAdaptiveCase && (
              <button
                onClick={() => setNewQuestionPaperMaper(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 14px",
                  border: "1px solid #FDE68A",
                  borderRadius: "8px",
                  backgroundColor: "#FFF7ED",
                  color: "#92400E",
                  fontWeight: 600,
                  fontSize: "13px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#FFEDD5";
                  e.currentTarget.style.borderColor = "#FCD34D";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#FFF7ED";
                  e.currentTarget.style.borderColor = "#FDE68A";
                }}
              >
                <Upload size={16} /> Import File
              </button>
            )}
          </div>

          {/* Right: Actions */}
          <div
            className="d-flex gap-2 align-items-center"
            style={{ flexShrink: 0 }}
          >
            <button
              onClick={() => {
                if (componentType === ComponentType.QUESTION_BANK) {
                  setClickFromCreate(false);
                } else {
                  setClickFromCreate(1);
                }
              }}
              style={{
                padding: "8px 16px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                backgroundColor: "#fff",
                color: "#111827",
                fontWeight: 500,
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              ← Back
            </button>
            <button
              disabled={
                !questions ||
                questions.length === 0 ||
                isMarksMismatch ||
                attentionCount > 0
              }
              onClick={handleNextClick}
              style={{
                padding: "8px 18px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#F28C28",
                color: "#fff",
                fontWeight: 600,
                fontSize: "13px",
                cursor:
                  !questions ||
                  questions.length === 0 ||
                  isMarksMismatch ||
                  attentionCount > 0
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  !questions ||
                  questions.length === 0 ||
                  isMarksMismatch ||
                  attentionCount > 0
                    ? 0.6
                    : 1,
              }}
            >
              Review & Save →
            </button>
          </div>
        </div>
      </div>

      {/* ========================================== */}
      {/* 2. STICKY HEADER 2 (Question Tray Title + Stats + Search) */}
      {/* ========================================== */}
      <div
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #E5E7EB",
          padding: "12px 24px",
          zIndex: 9,
          flexShrink: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        {/* Left: Title + Stats + Search */}
        <div className="d-flex align-items-center gap-3 flex-wrap">
          <div>
            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#111827",
                margin: 0,
                whiteSpace: "nowrap",
              }}
            >
              Question Tray
            </h3>
          </div>

          <div
            className="d-flex align-items-center gap-2 bg-light px-3 py-1 rounded-3"
            style={{
              border: "1px solid #E5E7EB",
              fontSize: "13px",
              fontWeight: 600,
              color: "#111827",
            }}
          >
            <span>{questions?.length || 0} Questions</span>
            <span style={{ color: "#9CA3AF" }}>•</span>
            <span>{totalMarks} Marks</span>
            {/* 👈 Marks target badge — SIRF non-QB ke liye */}
            {!isQuestionBank && maxMarks > 0 && (
              <>
                <span style={{ color: "#9CA3AF" }}>•</span>
                <span
                  style={{
                    color:
                      marksStatus === "match"
                        ? "#059669"
                        : marksStatus === "exceeded"
                          ? "#B91C1C"
                          : "#92400E",
                  }}
                >
                  {marksStatus === "match" ? "✓" : "⚠"} {totalMarks} /{" "}
                  {maxMarks}
                </span>
              </>
            )}
            {attentionCount > 0 && (
              <>
                <span style={{ color: "#9CA3AF" }}>•</span>
                <span style={{ color: "#F28C28" }}>
                  ⚠ {attentionCount} Need attention
                </span>
              </>
            )}
          </div>

          {/* 👈 Search Box — yahan header ke andar */}
          <div
            className="position-relative"
            style={{ width: "260px", flexShrink: 0 }}
          >
            <input
              type="search"
              placeholder="Search by Question No. or Title"
              className="search-input form-control rounded-pill ps-4"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              style={{
                fontSize: "13px",
                padding: "6px 14px 6px 32px",
                height: "34px",
              }}
            />
            <Search
              size={15}
              color="#9CA3AF"
              style={{
                position: "absolute",
                left: "11px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
              }}
            />
          </div>
        </div>

        {/* Right: Expand / Collapse */}
        <div className="d-flex gap-2">
          <button
            type="button"
            onClick={handleCollapseAll}
            style={{
              padding: "6px 12px",
              border: "1px solid #D1D5DB",
              borderRadius: "6px",
              background: "#fff",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            Collapse All
          </button>
          <button
            type="button"
            onClick={handleExpandAll}
            style={{
              padding: "6px 12px",
              border: "1px solid #D1D5DB",
              borderRadius: "6px",
              background: "#fff",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            Expand All
          </button>
        </div>
      </div>

      {/* ========================================== */}
      {/* 3. SCROLLABLE MAIN BODY (Only Questions) */}
      {/* ========================================== */}
      <div
        ref={scrollContainerRef}
        className="orange-scrollBar"
        style={{ flex: 1, overflowY: "auto", padding: "20px 24px" }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            paddingBottom: "100px",
          }}
        >
          {/* Questions List */}
          <div className="d-flex flex-column gap-2">
            {questions && questions.length > 0 ? (
              questions.map((question, index) => {
                const isQuestionLibraryComponent =
                  componentType === ComponentType.QUESTION_BANK;
                const skipOptionValidation = isQuestionLibraryComponent
                  ? question.question_type === "true"
                  : hasDescriptiveAutoAssessmentFlag &&
                    isAutoEvalMode &&
                    question.question_type === "true";

                const isMissingBasic =
                  !question.title ||
                  !question.skill_id ||
                  !question.type_id ||
                  !question.chapter_id ||
                  !question.correct_score ||
                  !question.difficulty_level;

                let isMissingOptions = false;
                if (question.type_id && !skipOptionValidation) {
                  if (
                    Array.isArray(question.options) &&
                    question.options.length > 0
                  ) {
                    isMissingOptions = question.options.some(
                      (opt) => !opt?.key || !opt?.value,
                    );
                  }
                  if (Array.isArray(question.correct_answers)) {
                    isMissingOptions =
                      isMissingOptions ||
                      question.correct_answers.some(
                        (ans) =>
                          question?.options?.length > 0 &&
                          (!ans?.option_key || ans.option_key.trim() === ""),
                      );
                  }
                }
                const isReady = !isMissingBasic && !isMissingOptions;

                // 👈 Check if current question is expanded
                const isExpanded = activeQuestions.includes(index);

                return (
                  <div
                    key={index}
                    ref={(el) => (questionRefs.current[index] = el)}
                    className="question-item"
                    style={{
                      border: isExpanded
                        ? "1.5px solid #F28C28"
                        : "1px solid #E5E7EB",
                      borderRadius: "10px",
                      backgroundColor: isExpanded ? "#FFF7ED" : "#fff",
                      transition: "all 0.2s ease",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      onClick={() => toggleQuestion(index)}
                      className="d-flex align-items-center justify-content-between"
                      style={{ padding: "12px 16px", cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center gap-3 flex-grow-1 min-w-0">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "36px",
                            height: "36px",
                            backgroundColor: "#FFF1E6",
                            color: "#F28C28",
                            borderRadius: "8px",
                            fontWeight: 700,
                            fontSize: "14px",
                            flexShrink: 0,
                          }}
                        >
                          Q{index + 1}
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                              color: "#111827",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {question.title || "Untitled Question"}
                          </div>
                          <div
                            className="d-flex align-items-center gap-2"
                            style={{
                              fontSize: "12px",
                              color: "#6B7280",
                              marginTop: "2px",
                            }}
                          >
                            <span>
                              {questionType?.find(
                                (t) => t.id === question.type_id,
                              )?.name || "No type"}
                            </span>
                            <span>•</span>
                            <span>{question.correct_score || 0} marks</span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        {isReady ? (
                          <span
                            style={{
                              fontSize: "11px",
                              color: "#059669",
                              backgroundColor: "#D1FAE5",
                              padding: "3px 8px",
                              borderRadius: "10px",
                              fontWeight: 500,
                            }}
                          >
                            Ready
                          </span>
                        ) : (
                          <span
                            style={{
                              fontSize: "11px",
                              color: "#C2410C",
                              backgroundColor: "#FFF7ED",
                              padding: "3px 8px",
                              borderRadius: "10px",
                              fontWeight: 600,
                              border: "1px solid #F28C28",
                            }}
                          >
                            Need attention
                          </span>
                        )}
                        <button
                          onClick={(e) => handleDeleteClick(index, e)}
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#FEE2E2")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                          title="Delete Question"
                        >
                          <Trash2 size={16} color="#DC2626" />
                        </button>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6B7280"
                          strokeWidth="2"
                          style={{
                            transform: isExpanded
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                        >
                          <path d="M6 9l6 6 6-6" />
                        </svg>
                      </div>
                    </div>

                    {isExpanded && (
                      <div
                        style={{
                          padding: "0 16px 16px 16px",
                          borderTop: "1px solid #F3F4F6",
                        }}
                      >
                        <div style={{ paddingTop: "16px" }}>
                          <DefaultQuestion
                            key={index}
                            nextQuestion={index}
                            selectedBox="auto-evaluate"
                            question={question}
                            setQuestions={setQuestions}
                            assessmentDetails={assessmentDetails}
                            componentType={componentType}
                            qArr={questions}
                            showErrorInputField={showErrorInputField}
                            setShowErrorInputField={setShowErrorInputField}
                            getErrorMsg={getErrorMsg}
                            isChecked={isChecked}
                            isActive={true}
                            chapter={chapters}
                            questionType={questionType}
                            hasDescriptiveAutoAssessment={true}
                            onToggle={() => {}}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div
                className="text-center"
                style={{
                  padding: "30px 20px",
                  color: "#9CA3AF",
                  fontSize: "13px",
                  border: "1px dashed #D1D5DB",
                  borderRadius: "10px",
                }}
              >
                No questions yet. Add your first question above.
              </div>
            )}

            <div
              className="d-flex justify-content-between align-items-center flex-wrap gap-2"
              style={{
                marginTop: "12px",
                padding: "12px 16px",
                backgroundColor: "#F9FAFB",
                borderRadius: "10px",
                border: "1px dashed #D1D5DB",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  checked={copyPrevSettings}
                  onChange={(e) => setCopyPrevSettings(e.target.checked)}
                  style={{
                    accentColor: "#F28C28",
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: "13px", color: "#4B5563" }}>
                  Copy previous settings
                </span>
              </div>
              <button
                id="Add-options-btn"
                type="button"
                onClick={addMoreQuestion}
                className="d-flex align-items-center gap-2 rounded-3 poppins-semibold"
                style={{
                  padding: "8px 16px",
                  border: "1px solid #F28C28",
                  color: "#C2410C",
                  backgroundColor: "#FFF7ED",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                <img
                  src="/images/add button.svg"
                  alt=""
                  style={{ width: 14 }}
                />{" "}
                Add Another Question
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ========================================== */}
      {/* 4. FINAL PREVIEW (PublishPreviewQB) */}
      {/* ========================================== */}
      {componentType === ComponentType.QUESTION_BANK && click && (
        <PublishPreviewQB
          setPreview={setClick}
          displayQuestions={questions}
          details={assessmentDetails}
          type={"create"}
          selectedBox={selectedBox}
          hasDescriptiveAutoAssessment={hasDescriptiveAutoAssessmentFlag}
        />
      )}
      {componentType !== ComponentType.QUESTION_BANK && click && (
        <QuestionListAssessment
          questions={questions}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          change={setClick}
          total_marks={findTotalMarks()}
          name={name}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          operationType={OperationType.CREATE}
          redirectStateData={redirectStateData}
          isChecked={isChecked}
          selectedBox={selectedBox}
        />
      )}

      {/* ========================================== */}
      {/* 5. BAaki MODALS & POPUPS */}
      {/* ========================================== */}
      {click1 && (
        <SelectFromLibr
          setOpenQuestionBox={setOpenQuestionBox}
          setClick1={setClick1}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={sourceLibrary}
          componentType={componentType}
          getquestiondata={getquestiondata}
          sourceQsBank={SourceLibrary.FROM_QS_BANK}
          selectedBox={selectedBox}
        />
      )}
      {openQuestionBox && (
        <AiGenerateQuestions
          setClick1={setClick1}
          setOpenQuestionBox={setOpenQuestionBox}
          setQuestions={setQuestions}
          assessmentDetails={assessmentDetails}
          questions={questions}
          sourceLibrary={SourceLibrary.FROM_AI_LIBRARY}
          componentType={componentType}
          getquestiondata={getquestiondata}
        />
      )}
      {isInProgress && (
        <div className="loader_bg">
          <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
        </div>
      )}

      {/* DELETE DIALOG */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", padding: "8px" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            fontWeight: 700,
            color: "#111827",
            pb: 1,
          }}
        >
          <div
            style={{
              backgroundColor: "#FEE2E2",
              color: "#DC2626",
              borderRadius: "50%",
              padding: "8px",
            }}
          >
            <WarningAmber fontSize="small" />
          </div>
          Delete Question?
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{ color: "#4B5563", fontSize: "14px" }}
          >
            Are you sure you want to delete{" "}
            <b>Q{(questionToDelete ?? 0) + 1}</b>? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px 24px 24px", gap: 1 }}>
          <Button
            onClick={() => setDeleteConfirmOpen(false)}
            variant="outlined"
            sx={{
              color: "#4B5563",
              borderColor: "#D1D5DB",
              borderRadius: "8px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteQuestion}
            variant="contained"
            sx={{ backgroundColor: "#DC2626", borderRadius: "8px" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* PROCESSING DIALOG */}
      {showProcessingDialog && (
        <Dialog open={true} maxWidth="xs" fullWidth>
          <DialogContent sx={{ textAlign: "center", py: 4 }}>
            <Box sx={{ mb: 2 }}>
              <div className="spinner-border text-primary" />
            </Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Saving as Draft...
            </Typography>
          </DialogContent>
        </Dialog>
      )}

      {/* QUESTION PAPER MAPPER */}
      {newQuestionPaperMaper && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ background: "rgba(0,0,0,0.3)", zIndex: 9998 }}
          />
          <QuestionPaperMapper
            onClose={() => setNewQuestionPaperMaper(false)}
            selectedBox={selectedBox}
            componentType={componentType}
            onSaveSubmit={(mapperData) => {
              handleMapperSave(mapperData);
              setNewQuestionPaperMaper(false);
            }}
          />
        </>
      )}
    </div>
  );
};

export default CreateQuestion;
